import {
  globalConstants,
  initialPagination,
  propertyConstants,
} from "../../constants";

const { SUCCESS, FAILURE } = globalConstants;
const {
  ALL_PROPERTY_TYPES,
  ALL_VIEW_TYPES,
  USER_PROPERTY_TYPES,
  ALL_FRESH_PROPERTY,
  ALL_FAVOURITES_PROPERTY,
  USER_FAVOURITES_PROPERTY,
  ALL_RECOMMENDED_PROPERTY,
  GET_PROPERTY_DETAIL_BY_ID,
  FAVOURITE_PROPERTY,
  INTERESTED_PROPERTY,
  ALL_RECOMMENDED_PROPERTY_BUTTON,
  ALL_PROPERTIES,
  ALL_PROPERTIES_PAGINATION,
  PROPERTY_ID,
} = propertyConstants;

const initialState = {
  allPropertiesPagination: initialPagination,
  allPropertyTypes: [],
  allViewTypes: [],
  userPropertyTypes: [],
  allFreshProperty: [],
  allFavouritesProperty: [],
  userFavouritesProperty: [],
  allRecommendedProperty: [],
  totalRecommendedProperties: 0,
  allFavouritesPropertyCount: 0,
  propertyDetail: {},
  allProperties: [],
  propertyId: null,
};

export const propertyReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_PROPERTY_TYPES + SUCCESS:
      return {
        ...state,
        allPropertyTypes: action.data,
      };
    case ALL_VIEW_TYPES + SUCCESS:
      return {
        ...state,
        allViewTypes: action.data,
      };
    case USER_PROPERTY_TYPES + SUCCESS:
      return { ...state, userPropertyTypes: action.data };
    case ALL_FRESH_PROPERTY + SUCCESS:
      return {
        ...state,
        allFreshProperty: action.data,
      };
    case ALL_RECOMMENDED_PROPERTY + SUCCESS:
      return {
        ...state,
        allRecommendedProperty: action.data.items,
        totalRecommendedProperties: action.data.total,
      };
    case ALL_PROPERTIES + SUCCESS:
      return {
        ...state,
        allProperties: action.data.items,
        allPropertiesPagination: {
          ...state.allPropertiesPagination,
          total: action.data.total,
        },
      };
    case ALL_RECOMMENDED_PROPERTY_BUTTON + SUCCESS:
      return {
        ...state,
        allRecommendedProperty: [
          ...state.allRecommendedProperty,
          ...action.data.items,
        ],
        totalRecommendedProperties: action.data.total,
      };
    case ALL_FAVOURITES_PROPERTY + SUCCESS:
      return {
        ...state,
        allFavouritesProperty: action.data.items,
        allFavouritesPropertyCount: action.data.total,
      };
    case USER_FAVOURITES_PROPERTY + SUCCESS:
      return {
        ...state,
        userFavouritesProperty: action.data,
      };
    case GET_PROPERTY_DETAIL_BY_ID + SUCCESS:
      return {
        ...state,
        propertyDetail: action.data,
      };

    case FAVOURITE_PROPERTY + FAILURE:
      return {
        ...state,
        propertyDetail: {
          ...state.propertyDetail,
          isFavourite: action.data.isFavourite ? false : true,
        },
      };

    case INTERESTED_PROPERTY + FAILURE:
      return {
        ...state,
        propertyDetail: {
          ...state.propertyDetail,
          isInterested: action.data.isInterested ? false : true,
        },
      };
    case ALL_PROPERTIES_PAGINATION:
      return { ...state, allPropertiesPagination: action.data };
    case PROPERTY_ID:
      return { ...state, propertyId: action.data };
    default:
      return state;
  }
};
